import React from "react";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { makeStyles } from "@material-ui/core/styles";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import banner from "assets/img/banner.jpg";
import KisetsuNavbar from "components/Header/KisetsuNavbar.js";

const useStyles = makeStyles(headersStyle);

export default function Header2() {
  const classes = useStyles();

  return (
    <div>
      <KisetsuNavbar />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: `url("${banner}")`,
          maxHeight: "80vh",
          display: "flex",
          alignItems: "center"
        }}
      >
        <div className={classes.conatinerHeader2}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={classNames(classes.mlAuto, classes.mrAuto, classes.textCenter)}
            >
              <h1 className={classes.title}>Kisetsu ile Tanışın</h1>
              <h4>
                Özel tasarım ajandalarla stilinizi yansıtın. Kalite, estetik ve
                fonksiyonelliği bir araya getirdik.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
